import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "href", "onClick", "onOpenChange", "open", "showCloseButton"];
import { syntheticEvent } from '../../utils/SyntheticEvent/SyntheticEvent';
import { Popover } from '../Popover/Popover';
import { Link } from '../Link';
import { Controllable } from '../Controllable/Controllable';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { useTheme } from 'foundations-theming/utils';
import { HelpLinkProvider, usePopoverHelpLinkContext } from './HelpLinkProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const HelpLinkComponent = _ref => {
  var _popoverHelpLinkConte;
  let {
      children,
      disabled = false,
      href,
      onClick,
      onOpenChange,
      open,
      showCloseButton = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const popoverHelpLinkContext = usePopoverHelpLinkContext();
  const handleLinkClick = evt => {
    if (disabled) return;
    if (onClick) onClick(evt);
    if (!evt.defaultPrevented && onOpenChange) {
      onOpenChange(syntheticEvent(!open));
    }
  };
  const popoverStylesOverrides = deepMerge({
    '& ul': {
      marginBlockStart: theme.space['0']
    }
  }, (_popoverHelpLinkConte = popoverHelpLinkContext === null || popoverHelpLinkContext === void 0 ? void 0 : popoverHelpLinkContext.popoverStylesOverrides) !== null && _popoverHelpLinkConte !== void 0 ? _popoverHelpLinkConte : {});
  return /*#__PURE__*/_jsx(HelpLinkProvider, {
    popoverStylesOverrides: popoverStylesOverrides,
    children: /*#__PURE__*/_jsx(Popover, Object.assign({
      showCloseButton: showCloseButton,
      onOpenChange: onOpenChange,
      open: !disabled && open,
      use: "longform"
    }, rest, {
      children: /*#__PURE__*/_jsx(Link, {
        href: href,
        onClick: handleLinkClick,
        disabled: disabled,
        children: children
      })
    }))
  });
};
export const HelpLink = Controllable(HelpLinkComponent, ['open']);